module.exports = __webpack_public_path__ + "img/lieu-visite-bordeaux.0731872e.svg";